"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processResumeMutations = processResumeMutations;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _rdfMutationHelpers = require("../shared/rdfMutationHelpers");
var _idNodeFactory = require("../shared/idNodeFactory");
var _texts = require("../../texts");
function asXsdDateLiteral(dateLike) {
  const value = (dateLike?.value || '').trim();
  if (!value) return null;
  const dateOnly = value.slice(0, 10);
  return (0, _rdflib.literal)(dateOnly, _solidUi.ns.xsd('date'));
}

/* The following helper was generated by AI Model: GPT-5.3-Codex. */
/* Prompt: write me a function to determine PastRole, CurrentRole, or FutureRole based on resume role date data. 
           The function should return a NamedNode with the correct solid namespace and role type local name. 
           The function should use the roleType field if it is set to one of those three values, 
           otherwise it should infer the role type based on the start and end dates and isCurrentRole field. */
function membershipTypeForRole(resumeData) {
  const normalizedRoleType = (resumeData.roleType || '').trim();
  if (normalizedRoleType === 'PastRole' || normalizedRoleType === 'CurrentRole' || normalizedRoleType === 'FutureRole') {
    return _solidUi.ns.solid(normalizedRoleType);
  }
  if (resumeData.isCurrentRole) return _solidUi.ns.solid('CurrentRole');
  const todayIso = new Date().toISOString().slice(0, 10);
  const startIso = resumeData.startDate?.value?.slice(0, 10) || '';
  const endIso = resumeData.endDate?.value?.slice(0, 10) || '';
  if (startIso && startIso > todayIso) return _solidUi.ns.solid('FutureRole');
  if (endIso && endIso < todayIso) return _solidUi.ns.solid('PastRole');
  return _solidUi.ns.solid('FutureRole');
}
function roleTypeNode(orgType) {
  const text = (orgType || '').trim();
  if (!text) return null;

  // These are membership role classes, not organization classes.
  if (text === 'PastRole' || text === 'CurrentRole' || text === 'FutureRole') {
    return null;
  }
  if (text.startsWith('http://') || text.startsWith('https://')) {
    const local = text.split(/[#/]/).pop();
    if (local === 'PastRole' || local === 'CurrentRole' || local === 'FutureRole') {
      return null;
    }
    return (0, _rdflib.sym)(text);
  }
  const prefixed = text.match(/^([a-zA-Z][\w-]*):(.*)$/);
  if (prefixed) {
    const prefix = prefixed[1].toLowerCase();
    const local = prefixed[2].trim();
    if (!local) return null;
    if (local === 'PastRole' || local === 'CurrentRole' || local === 'FutureRole') {
      return null;
    }
    /* Organization types vary need to return the correct namespace */
    if (prefix === 'schema') return _solidUi.ns.schema(local);
    if (prefix === 'vcard') return _solidUi.ns.vcard(local);
    if (prefix === 'solid') return _solidUi.ns.solid(local);
    if (prefix === 'org') return _solidUi.ns.org(local);
    return null;
  }

  // For plain values like "Corporation", map to schema:Corporation.
  return _solidUi.ns.schema(text);
}

/* The following helper was generated by AI Model: GPT-5.3-Codex.
   Prompt: 'do you see anything I can do differently in the mutation code so that it's not so verbose and possible reusable accross sections' */
function buildOrganizationStatements(doc, membershipNode, resumeData) {
  if (!resumeData.orgName && !resumeData.orgType && !resumeData.orgLocation && !resumeData.orgHomePage) {
    return [];
  }
  const organizationNode = (0, _idNodeFactory.createIdNode)(doc);
  const inserts = [(0, _rdflib.st)(membershipNode, _solidUi.ns.org('organization'), organizationNode, doc)];
  const organizationClassNode = roleTypeNode(resumeData.orgType || '');
  if (organizationClassNode) {
    inserts.push((0, _rdflib.st)(organizationNode, _solidUi.ns.rdf('type'), organizationClassNode, doc));
  }
  inserts.push((0, _rdflib.st)(organizationNode, _solidUi.ns.rdf('type'), _solidUi.ns.vcard('Organization'), doc));
  if (resumeData.orgName) {
    inserts.push((0, _rdflib.st)(organizationNode, _solidUi.ns.schema('name'), (0, _rdflib.literal)(resumeData.orgName), doc));
  }
  if (resumeData.orgLocation) {
    inserts.push((0, _rdflib.st)(organizationNode, _solidUi.ns.org('location'), (0, _rdflib.literal)(resumeData.orgLocation), doc));
  }
  if (resumeData.orgHomePage) {
    inserts.push((0, _rdflib.st)(organizationNode, _solidUi.ns.schema('uri'), (0, _rdflib.literal)(resumeData.orgHomePage), doc));
  }
  return inserts;
}
function buildResumeStatements(subject, doc, node, resumeData, includeMembershipLink = true) {
  const inserts = [];
  if (includeMembershipLink) {
    inserts.push((0, _rdflib.st)(node, _solidUi.ns.org('member'), subject, doc));
  }
  inserts.push((0, _rdflib.st)(node, _solidUi.ns.rdf('type'), membershipTypeForRole(resumeData), doc));
  if (resumeData.title) {
    inserts.push((0, _rdflib.st)(node, _solidUi.ns.vcard('role'), (0, _rdflib.literal)(resumeData.title), doc));
  }
  if (resumeData.startDate) {
    const startDateLiteral = asXsdDateLiteral(resumeData.startDate);
    if (startDateLiteral) {
      inserts.push((0, _rdflib.st)(node, _solidUi.ns.schema('startDate'), startDateLiteral, doc));
    }
  }
  if (resumeData.endDate && !resumeData.isCurrentRole) {
    const endDateLiteral = asXsdDateLiteral(resumeData.endDate);
    if (endDateLiteral) {
      inserts.push((0, _rdflib.st)(node, _solidUi.ns.schema('endDate'), endDateLiteral, doc));
    }
  }
  if (resumeData.description) {
    inserts.push((0, _rdflib.st)(node, _solidUi.ns.schema('description'), (0, _rdflib.literal)(resumeData.description), doc));
  }
  inserts.push(...buildOrganizationStatements(doc, node, resumeData));
  return inserts;
}
async function mutateResumeEntries(store, subject, resumeOps) {
  const doc = subject.doc();
  const existingResumeNodes = store.each(null, _solidUi.ns.org('member'), subject, doc);
  const deletions = [];
  const insertions = [];
  resumeOps.remove.forEach(resume => {
    if (!resume.entryNode) return;
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingResumeNodes, resume.entryNode);
    if (existingNode) {
      const linkedOrganizations = (0, _rdfMutationHelpers.collectLinkedNodeStatements)(store, existingNode, _solidUi.ns.org('organization'), doc);
      deletions.push(...linkedOrganizations.linkedStatements);
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
    }
  });
  resumeOps.update.forEach(resume => {
    if (!resume.entryNode) return;
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingResumeNodes, resume.entryNode);
    if (!existingNode) {
      throw new Error(_texts.resumeUpdateEntryNotFoundErrorMessageText);
    }
    if (existingNode.termType === 'BlankNode') {
      // Blank node labels are not always stable for remote updates; migrate to a named node.
      const migratedNode = (0, _idNodeFactory.createIdNode)(doc);
      insertions.push(...buildResumeStatements(subject, doc, migratedNode, resume, true));
      return;
    }

    // For updates on existing named memberships, keep the membership link and replace only mutable fields.
    ;
    [_solidUi.ns.rdf('type'), _solidUi.ns.vcard('role'), _solidUi.ns.schema('startDate'), _solidUi.ns.schema('endDate'), _solidUi.ns.schema('description')].forEach(predicate => {
      (0, _rdfMutationHelpers.replacePredicateStatements)(store, existingNode, predicate, doc, deletions, insertions, null);
    });
    const linkedOrganizations = (0, _rdfMutationHelpers.collectLinkedNodeStatements)(store, existingNode, _solidUi.ns.org('organization'), doc);
    deletions.push(...linkedOrganizations.linkedStatements);
    deletions.push(...linkedOrganizations.linkStatements);
    insertions.push(...buildResumeStatements(subject, doc, existingNode, resume, false));
  });
  resumeOps.create.forEach(resume => {
    insertions.push(...buildResumeStatements(subject, doc, (0, _idNodeFactory.createIdNode)(doc), resume));
  });
  await (0, _rdfMutationHelpers.applyUpdaterPatch)(store, deletions, insertions);
}
async function processResumeMutations(store, subject, mutationPlan) {
  try {
    await mutateResumeEntries(store, subject, mutationPlan);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`${_texts.mutationSaveResumeFailedPrefixText} ${message}`);
  }
}